// Note! The `--dropdown-z-index` property is used from `picker.tsx`.
/**
  * @prop --dropdown-z-index: z-index of the dropdown menu.
  */

:host {
    position: relative;
    display: block;
}

:host([hidden]) {
    display: none;
}
